export const MV_MOVIE = {
  init: function () {
    $(document).ready(function () {
      const $video = $('#load_movie')
      const paths = {
        sp: '/wp-content/themes/try-ex/assets/img/top/hero_im01_sp.mp4',
        pc: '/wp-content/themes/try-ex/assets/img/top/hero_im01.mp4',
        spPoster: '/wp-content/themes/try-ex/assets/img/top/mv_poster_sp.jpg',
        pcPoster: '/wp-content/themes/try-ex/assets/img/top/mv_poster_pc.jpg',
      }
      const replaceWidth = 768
      let currentSource = ''

      // 動画のパスとポスターを設定
      const setVideoAttributes = (source, poster) => {
        if (currentSource === source) return // 同じソースの場合は処理をスキップ
        $video.attr('src', source)
        $video.attr('poster', poster)
        currentSource = source // 現在のソースを記録
        $video.get(0).load() // 動画を再読み込み
        $video.get(0).play()
      }

      // ウィンドウサイズに応じた動画の切り替え
      const videoSwitch = () => {
        if (!$video.length) {
          return
        }

        const isPc = window.matchMedia(`(min-width: ${replaceWidth}px)`).matches
        if (isPc) {
          setVideoAttributes(paths.pc, paths.pcPoster)
        } else {
          setVideoAttributes(paths.sp, paths.spPoster)
        }
      }

      // 初回実行
      videoSwitch()

      // ウィンドウサイズ変更時の処理
      let resizeTimer
      $(window).on('resize orientationchange', () => {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
          videoSwitch()
        }, 200)
      })
    })
  },
}
